import "./AlertError.scss";

import { Alert, ExclamationTriangleIcon } from "@fluentui/react-northstar";
import React from "react";

type AlertErrorProps = {
  prependMessage?: React.ReactNode;
  error: Error;
  onClick: () => void;
};

export const AlertError: React.FC<AlertErrorProps> = ({ error, onClick, prependMessage }) => {
  return (
    <Alert
      danger
      content={
        prependMessage ? (
          <>
            {prependMessage} {error.message}
          </>
        ) : (
          error.message
        )
      }
      icon={<ExclamationTriangleIcon />}
      actions={[
        {
          key: "try_again",
          content: "Try Again",
          size: "smallest",
          onClick,
        },
      ]}
    />
  );
};
